export default "__VITE_ASSET__36c71904__"